import { render, staticRenderFns } from "./addWechat.vue?vue&type=template&id=5caf3076&scoped=true"
import script from "./addWechat.vue?vue&type=script&lang=js"
export * from "./addWechat.vue?vue&type=script&lang=js"
import style0 from "./addWechat.vue?vue&type=style&index=0&id=5caf3076&prod&lang=scss&scoped=true"
import style1 from "./addWechat.vue?vue&type=style&index=1&id=5caf3076&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5caf3076",
  null
  
)

export default component.exports